import * as React from "react";

export const Location: React.FC<IProps> = ({ width }) => (
  <svg viewBox="0 0 50 50" width={width}>
    <path
      d="M25 28.125a7.813 7.813 0 117.813-7.813A7.822 7.822 0 0125 28.125zm0-12.5a4.687 4.687 0 100 9.374 4.687 4.687 0 000-9.374z"
      fill="currentColor"
    />
    <path
      d="M25 46.875L11.819 31.33a54.555 54.555 0 01-.544-.705 17.014 17.014 0 01-3.462-10.313 17.188 17.188 0 0134.374 0 17.006 17.006 0 01-3.46 10.308l-.002.005s-.469.616-.539.698L25 46.875zM13.769 28.742c.003 0 .365.481.448.585L25 42.044l10.797-12.735c.069-.086.434-.57.436-.572a13.908 13.908 0 002.83-8.424 14.063 14.063 0 00-28.126 0 13.915 13.915 0 002.833 8.43h-.001z"
      fill="currentColor"
    />
  </svg>
);

export const ArrowLeft: React.FC<IProps> = ({ width }) => (
  <svg width={width} fill="none" viewBox="0 0 38 34">
    <path
      d="M16.9166 2.41666L2.33331 17L16.9166 31.5833"
      stroke="currentColor"
      strokeWidth="4.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33331 17H35.6666"
      stroke="currentColor"
      strokeWidth="4.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChevronRight: React.FC<IProps> = ({ width }) => (
  <svg width={width} fill="none" viewBox="0 0 24 24">
    <g id="UI-Kit">
      <g id="Cable-UI-Kit">
        <g id="Icon-_-Chevron" data-name="Icon-/-Chevron">
          <polygon
            fill="currentColor"
            points="7.01 24 4.99 21.98 14.97 12 4.99 2.02 7.01 0 19.01 12 7.01 24"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const LocationArrow: React.FC<IProps> = ({ width }) => (
  <svg width={width} viewBox="0 0 42 42" fill="none">
    <path
      d="M40.0625 1.95833C39.2666 1.147 38.2572 0.577537 37.1512 0.31578C36.0452 0.0540231 34.8877 0.110669 33.8125 0.479167L4.33333 10.3333C3.14441 10.7225 2.1056 11.4711 1.36032 12.4759C0.615038 13.4807 0.200034 14.692 0.172597 15.9427C0.145159 17.1934 0.506641 18.4218 1.20714 19.4583C1.90764 20.4948 2.91262 21.2882 4.08333 21.7292L15 25.8958C15.2486 25.9909 15.4749 26.1361 15.6649 26.3225C15.8549 26.5089 16.0044 26.7324 16.1042 26.9792L20.2708 37.9167C20.695 39.0708 21.4646 40.0661 22.4749 40.767C23.4852 41.4679 24.6871 41.8402 25.9167 41.8333H26.0625C27.3146 41.8105 28.5282 41.3965 29.5332 40.6493C30.5382 39.9021 31.2842 38.8592 31.6667 37.6667L41.5208 8.14583C41.8792 7.08112 41.9326 5.93738 41.6748 4.84393C41.4171 3.75048 40.8586 2.75094 40.0625 1.95833V1.95833ZM37.6667 6.83333L27.7083 36.375C27.5927 36.7489 27.3605 37.076 27.0456 37.3084C26.7307 37.5408 26.3497 37.6663 25.9583 37.6667C25.5693 37.673 25.1875 37.5609 24.8637 37.345C24.54 37.1292 24.2896 36.8199 24.1458 36.4583L19.9792 25.5208C19.6771 24.7261 19.2112 24.0038 18.6118 23.4008C18.0124 22.7978 17.2929 22.3276 16.5 22.0208L5.5625 17.8542C5.19353 17.719 4.87636 17.4712 4.6558 17.146C4.43524 16.8208 4.32244 16.4345 4.33333 16.0417C4.33365 15.6503 4.4592 15.2693 4.69161 14.9544C4.92403 14.6395 5.25111 14.4073 5.625 14.2917L35.1667 4.4375C35.5058 4.29926 35.8778 4.26223 36.2376 4.33089C36.5973 4.39954 36.9295 4.57093 37.1939 4.82435C37.4584 5.07776 37.6437 5.40235 37.7276 5.75888C37.8115 6.1154 37.7904 6.48859 37.6667 6.83333V6.83333Z"
      fill="currentColor"
    />
  </svg>
);

export const Close: React.FC<IProps> = ({ width }) => (
  <svg width={width} viewBox="0 0 24 24">
    <path d="M24 22.3L13.65 11.94 24 1.59 22.41 0 12.06 10.35 1.71 0 0 1.71l10.35 10.35L0 22.41 1.59 24l10.35-10.35L22.29 24 24 22.3z" />
  </svg>
);

interface IProps {
  width?: number;
}
